<template>
	<div class='pcard warp'>
    <div class="container">
      <h2 class="h2title">{{title}}</h2>
      <p class="descript">{{des}}</p>
      <mu-row class="mt30 mu-row-pc" gutter>
        <mu-col span="4" v-for="item in list" :key="item.id">
          <mu-paper class="round10" :z-depth="2">
            <a href="#"><img class="item-img img-responsive" :src="item.pic" :alt="item.name"></a>
            <div class="text-box">
              <a href="#"><h2>{{item.name}}</h2></a>
              <div class="text">{{item.description}}</div>
            </div>
          </mu-paper>
        </mu-col>
      </mu-row>
      <mu-row class="mt30 mu-row-mobile">
        <mu-col class="mt30" v-for="item in list" :key="item.id">
          <mu-paper class="" :z-depth="2">
            <a href="#"><img class="item-img img-responsive" :src="item.pic" :alt="item.name"></a>
            <div class="text-box">
              <a href="#"><h2>{{item.name}}</h2></a>
              <div class="text">{{item.description}}</div>
            </div>
          </mu-paper>
        </mu-col>
      </mu-row>
    </div>
	</div>
</template>
<script>
export default {
  name: 'pcard',
  props: {
    title: {
      type: String,
      default: '最新项目'
    },
    des: {
      type: String,
      default: '人们对新产品的需求不断增加，国家对环境保护和安全生产也越来越重视'
    },
    list: {
      type: Array,
      // default: function () {
      //   return []
      // }
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style>
.pcard{
  text-align: center;
}
.mu-row-mobile{
  display: none;
}
mu-row-pc{
  display: block;
}
@media screen and ( max-width: 768px){
  .warp{
    width: 100% !important;
  } 
  .mu-row-pc{
    display: none !important;
  }
  .mu-row-mobile{
    display: block !important;
  }
}
@media screen and ( max-width: 320px) {			
}
</style>